import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  text: string;
  delay?: number;
}
function TestimonialCard({
  text,
  delay = 0
}: TestimonialCardProps) {
  return <AnimateOnScroll delay={delay} data-id="element-2102">
      <div className="bg-[#111111] p-8 lg:p-10 border-l-[3px] border-[#FF1493]" data-id="element-2103">
        {/* Quote Icon */}
        <div className="text-[#FF1493] text-4xl font-serif mb-4 leading-none select-none" data-id="element-2104">
          &ldquo;
        </div>

        {/* Text */}
        <p className="text-white text-base leading-[1.7] font-body mb-6" data-id="element-2105">
          {text}
        </p>

        {/* Stars + Attribution */}
        <div className="flex gap-1 mb-3" data-id="element-2106">
          {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2107" />)}
        </div>
        <p className="text-[#B0B0B0] text-[13px] uppercase tracking-widest font-[Poppins,_sans-serif]" data-id="element-2108">
          — Verified Patient
        </p>
      </div>
    </AnimateOnScroll>;
}
export function TestimonialsGrid() {
  const testimonials = ['This was my first time at this clinic and I will definitely keep coming back! The clinic is super clean and beautiful. I went in for fillers which were done by Leah & she did amazing...she took her time making sure my lips were even and kept checking in with me afterwards to see how I was liking my lips. I highly recommend this place!', '5-stars across the board! I have done a handful of treatments here and am always blown away with the outcome. These nurses are so professional and they take the time to make you feel comfortable, educated and excited for each and every treatment. Thank you Be CLINICAL for everything you do!', "Jamie is the best injector I've ever had and I used to manage a Plastic Surgery clinic! She is a perfectionist and a great nurse! Her work is amazing and she knows exactly what she's talking about. I am so grateful to her for all she does and for her dedication and commitment to her profession.", 'This team is amazing! Dr. Fiona Frie is not only a skin genius but truly an expert in the actual science behind what they do. The sheer fact that Be Clinical can actually explain the processes behind their treatments is exactly why I hold them in such high regard.', 'Everyone here was so welcoming and friendly. Had an appointment with Leah and she was super easy going and informative regarding specifics on any questions I had about my treatment. Definitely recommend this place for not only being a good, clean environment with a range of services.', "I've been coming to Be CLINICAL for over a year now and I can honestly say it's been life-changing. The staff is incredibly knowledgeable and always makes me feel comfortable. The results speak for themselves — I've never felt more confident in my own skin."];
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-2109">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2110">
        {/* Heading */}
        <AnimateOnScroll className="text-center mb-12" data-id="element-2111">
          <h2 className="text-[28px] sm:text-4xl lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-2112">
            WHAT OUR PATIENTS SAY
          </h2>
          <div className="w-[60px] h-[2px] bg-[#FF1493] mx-auto" data-id="element-2113"></div>
        </AnimateOnScroll>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-2114">
          {testimonials.map((text, index) => <TestimonialCard key={index} text={text} delay={index * 100} data-id="element-2115" />)}
        </div>
      </div>
    </section>;
}